import type { ScaleLinear } from "d3";

interface Params {
  context: CanvasRenderingContext2D;
  yScale: ScaleLinear<number, number>;
  stopColors: [string, string];
  stopValue?: number;
  height: number;
}

export function miniGameChartsOrderGradient(params: Params): CanvasGradient {
  const { context, yScale, stopValue, stopColors, height } = params;
  const gradient = context.createLinearGradient(0, 0, 0, height);

  gradient.addColorStop(0, stopColors[0]);
  gradient.addColorStop(1, stopColors[1]);

  if (typeof stopValue === "number" && Number.isFinite(stopValue)) {
    const stopColorStep = 1 / height;
    const [minStopValue, maxStopValue] = yScale.domain();
    let nextStopValue = stopValue;

    if (minStopValue > stopValue) {
      nextStopValue = minStopValue;
    }

    if (maxStopValue < stopValue) {
      nextStopValue = maxStopValue;
    }

    const value = yScale(nextStopValue) * stopColorStep;

    if (Number.isFinite(value) && value >= 0) {
      gradient.addColorStop(value, stopColors[0]);
      gradient.addColorStop(value, stopColors[1]);
    }
  }

  return gradient;
}
